import _ from "lodash";

export const entity = {
    name: 'Contact',
    facets: ['firstLastName', 'conversations'],
    fields: [
        { type: 'GroupAndCompany'},
        'Civility',
        {type: 'Function', nullable: true},
        'email',
        'phone',
        'position',
        'linkedin',
        {path: 'status', type: 'ContactStatus'},
        {type: 'Influence', nullable: true},
        {path: 'state', type: 'Status'}
    ],
    filters: [
        {
            name: 'byGroupAndCompany',
            isDefault: false,
            query: function(context) {
                const groupAndCompanyId = _.get(context.data, 'groupAndCompany.id')
                if (groupAndCompanyId)
                    return {groupAndCompany: new global.ObjectID(groupAndCompanyId)}
                return {_id: null}
            }
        },
        {
            name: 'byState',
            path: "state",
            object: "Status",
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const status = _.get(context, 'data.state.id');
                return status ? {state: status} : {};
            }
        }
    ],
}

export const module_ = {
    object: 'Contact',
    category: {
        path: 'referential',
        icon: 'server'
    },
    defaultSortBy: 'firstName',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'groupAndCompany', initiallyNotVisible: true},
            {
                path: 'civility',
                display: 'name'
            },
            'firstName',
            'lastName',
            'function',
            { path: 'position'},
            'email',
            'phone',
            { path: 'linkedin', initiallyNotVisible: true },
            'status',
            {path: 'influence', initiallyNotVisible: true},
            {path: 'state', initiallyNotVisible: true},
        ],
        form: [
            {path: 'groupAndCompany', display: 'fullName', placeholder : 'sélectionner le groupe ou la société du contact'},
            {path: 'civility', placeholder : 'sélectionner la civilité du contact'},
            {path: 'firstName', required: true},
            {path: 'lastName', required: true},
            {path: 'function', display: 'fullName', placeholder : 'sélectionner le métier du contact'},
            {path: 'position', placeholder : 'renseigner la fonction du contact'},
            {path: 'email', placeholder : 'renseigner le courriel du contact', emailAddress: true},
            {path: 'phone', type: 'phoneNumber'},
            {path: 'linkedin', tKey: 'linkedIn', placeholder : 'renseigner le lien LinkedIn du contact'},
            {path: 'status', placeholder : 'sélectionner le statut du contact'},
            {path: 'influence', placeholder : 'sélectionner le niveau d’influence du contact'},
            {path: 'conversations', tKey: 'suivi'},
            {path: 'state', type: 'toggle', default: {id: 'actif'}},
        ]
    },
    filters: [
        {
            path: 'company',
            tKey: 'groupAndCompany',
            object: 'GroupAndCompany',
            display: 'fullName',
            client: true,
            clearable: true,
            default: null,
            query: function(context) {
                const companyId = _.get(context.data, 'company.id')
                if (companyId)
                    return { groupAndCompany: new global.ObjectID(companyId) }
                return {}
            }
        },
        'byState'
    ]
}
